import { Box, Button } from "@mui/material";
import React from "react";
import { HighlightSelectBox } from "../highLightSelectBox";
import { SelectBoxOption } from "../../interfaces";
import { User } from "../../redux/services";

export const AddEditUser: React.FC<{
    data: SelectBoxOption[],
    users: User[],
    isLoading: boolean,
    isFetching: boolean,
    isError: boolean,
    onUpdate: (users: User[]) => void
}> = ({
    data = [],
    users = [],
    isLoading,
    isFetching,
    isError,
    onUpdate
}) => {

        const [userStack, setUserStack] = React.useState<User[]>(users);

        return <Box>
            <HighlightSelectBox
                size="medium"
                margin="none"
                multiple
                options={data ? data : []}
                label={'Assign To'}
                value={userStack as unknown as SelectBoxOption[]}
                onChange={(option: any) => setUserStack(option as User[])}
                loading={isLoading || isFetching}
                error={isError}
                helperText={isError ? "Something went wrong, Unable to fetch users." : ""}
            />

            <Button
                fullWidth
                variant="contained"
                sx={{ marginTop: 2 }}
                onClick={(e) => onUpdate(userStack)}
            >Update</Button>
        </Box>
    }